import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { getPatients, getPatientById, createPatient, updatePatient, deletePatient } from "../api/patients"

export const useFetchPatients = (offset, limit, search) => {
  return useQuery({
    queryKey: ["patients", offset, limit, search],
    queryFn: () => getPatients({ offset, limit, search }),
    select: (response) => ({
      patients: response.data.data.patients,
      pagination: {
        total: response.data.data.total,
        totalPages: Math.ceil(response.data.data.total / limit),
      },
    }),
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
  })
}

export const useFetchPatient = (patientId) => {
  return useQuery({
    queryKey: ["patient", patientId],
    queryFn: () => getPatientById(patientId),
    select: (response) => response.data.data,
    enabled: !!patientId,
  })
}

export const useCreatePatient = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createPatient,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patients"] })
    },
  })
}

export const useUpdatePatient = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ patientId, data }) => updatePatient(patientId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patients"] })
    },
  })
}

export const useDeletePatient = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deletePatient,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patients"] })
    },
  })
}
